export const NAME = "name";
export const DESCRIPTION = "description";
export const STATUS = "isActive"
export const START_DATE = "startDate"
export const END_DATE = "endDate"
export interface FilterType {
  orderBy: string;
  orderDirection: string;
  name?: string; // 👈 optional
}

export const DEFAULT_FILTER: FilterType = {
  
  orderBy: "updatedAt",
  orderDirection: "DESC",
};

